import { BsTwitterX } from 'react-icons/bs';
import {
  FaApple,
  FaFacebookF,
  FaGooglePlay,
  FaInstagram,
} from 'react-icons/fa';
import {
  FaLocationDot,
  FaMinus,
  FaPhone,
  FaRegCopyright,
} from 'react-icons/fa6';
import { IoIosMail } from 'react-icons/io';
import { Parallax } from 'react-parallax';
import juryRoom from '../../assets/jury_room.jpg';
import { navMenuItems } from '../../constants/settings';
import AppDownloadButton from './Buttons/AppDownloadButton';
import FooterNavButton from './Buttons/FooterNavButton';
import SocialButton from './Buttons/SocialButton';
import ArrowIcon from './Icons/ArrowIcon';

const Footer = () => {
  // rendering footer section here
  return (
    <footer className='bg-legal-black text-legal-white'>
      <Parallax
        bgImage={juryRoom}
        bgImageAlt='jury room'
        strength={500}
        bgClassName='object-center object-cover xl:-mt-[220px]'
      >
        <div className='flex h-[300px] items-center justify-between bg-legal-dark-blue/80'>
          <a
            href='/'
            className='group mx-auto flex w-[95%] max-w-[1800px] flex-col items-center justify-between md:flex-row lg:w-[90%] xl:w-4/5'
          >
            <div className='block items-center justify-center gap-10 space-y-3 md:flex lg:hidden'>
              <p className='font-marcellus text-6xl font-semibold md:text-5xl'>
                Let's Get Started
              </p>

              <div className='w-full md:flex-1'>
                <ArrowIcon width={'100%'} height={80} />
              </div>
            </div>

            <div className='hidden h-20 overflow-hidden lg:block'>
              <div className='-translate-y-1/2 space-y-2 duration-500 group-hover:translate-y-0'>
                <p className='font-marcellus text-7xl font-semibold'>
                  Let's Get Started
                </p>

                <p className='font-marcellus text-7xl font-semibold'>
                  Let's Get Started
                </p>
              </div>
            </div>

            <div className='hidden w-[300px] overflow-hidden lg:block xl:w-[400px]'>
              <div className='flex w-[200%] -translate-x-1/2 items-center justify-center gap-10 duration-500 group-hover:translate-x-0'>
                <ArrowIcon width={'50%'} height={80} />

                <ArrowIcon width={'50%'} height={80} />
              </div>
            </div>
          </a>
        </div>
      </Parallax>

      <div className='mx-auto w-[95%] lg:w-[90%] xl:w-4/5 max-w-[1800px] py-10'>
        <div className='flex flex-col items-stretch justify-between gap-8 py-10 md:flex-row md:items-start'>
          <div className='space-y-8'>
            <div className='text-center md:text-left'>
              <h2 className='text-3xl font-semibold italic text-legal-brown'>
                My
                <span className='font-marcellus not-italic text-legal-white'>
                  Legal
                </span>
                ites
              </h2>

              <p className='lg:w- mt-2 w-fit font-marcellus text-sm font-semibold text-legal-light-gray md:w-[300px] lg:w-fit'>
                This is a trademark authorized website of{' '}
                <span className='font-playfair font-semibold italic text-legal-brown'>
                  Legalites
                </span>
                . <br className='hidden lg:block' /> Any kind of copyright
                infringement will cause taking legal{' '}
                <br className='hidden lg:block' /> actions against the person or
                group of persons.
              </p>
            </div>

            <div className='flex items-center justify-center gap-3 md:justify-start'>
              <SocialButton
                href='https://www.facebook.com/'
                icon={<FaFacebookF className='size-5' />}
              />
              <SocialButton
                href='https://www.instagram.com/'
                icon={<FaInstagram className='size-6' />}
              />
              <SocialButton
                href='https://www.x.com/'
                icon={<BsTwitterX className='size-5' />}
              />
            </div>

            <div className='flex md:hidden lg:flex items-center justify-center md:justify-start gap-5'>
              <AppDownloadButton
                href='/'
                icon={<FaGooglePlay className='size-7' />}
                label='get it on'
                appName='google play'
              />

              <AppDownloadButton
                href='/'
                icon={<FaApple className='size-8' />}
                label='available on the'
                appName='app store'
              />
            </div>
          </div>

          <div className='space-y-3 text-center md:text-left md:[&>div]:pl-2'>
            <h3 className='text-2xl font-semibold'>Contact</h3>

            <div className='flex items-start justify-center gap-1 md:justify-start'>
              <FaLocationDot className='mt-1 text-legal-brown' />
              <p className='font-marcellus font-semibold text-legal-light-gray'>
                0665 Broadway st. <br /> 10234 BC, CANADA
              </p>
            </div>

            <div className='flex items-start justify-center gap-1 md:justify-start'>
              <FaPhone className='mt-1 text-legal-brown' />
              <p className='font-marcellus font-semibold text-legal-light-gray'>
                +1 123 567 8910
              </p>
            </div>

            <div className='flex items-start justify-center gap-1 md:justify-start'>
              <IoIosMail className='mt-1 size-5 text-legal-brown' />
              <a
                href='mailto:info@legalites.com'
                className='border-b border-legal-brown pb-[2px] font-marcellus font-semibold text-legal-light-gray duration-300 hover:text-legal-white'
              >
                info@legalites.com
              </a>
            </div>

            <div className='flex items-start justify-center gap-1 md:justify-start'>
              <IoIosMail className='mt-1 size-5 text-legal-brown' />
              <a
                href='mailto:support@legalites.com'
                className='border-b border-legal-brown pb-[2px] font-marcellus font-semibold text-legal-light-gray duration-300 hover:text-legal-white'
              >
                support@legalites.com
              </a>
            </div>
          </div>

          <div className='space-y-3 text-center md:text-left'>
            <h3 className='text-2xl font-semibold'>Quick Links</h3>

            <ul className='space-y-1 font-marcellus md:pl-2'>
              {navMenuItems.map((item, index) => (
                <FooterNavButton
                  key={index}
                  href={item.href}
                  label={item.label}
                />
              ))}
            </ul>
          </div>
        </div>

        <div className='hidden md:flex lg:hidden items-center justify-start gap-5'>
          <AppDownloadButton
            href='/'
            icon={<FaGooglePlay className='size-7' />}
            label='get it on'
            appName='google play'
          />

          <AppDownloadButton
            href='/'
            icon={<FaApple className='size-8' />}
            label='available on the'
            appName='app store'
          />
        </div>
      </div>

      <div className='border-t border-gray-700 py-2 font-marcellus text-sm'>
        <div className='mx-auto flex w-[95%] lg:w-[90%] xl:w-4/5 max-w-[1800px] flex-col items-center justify-between lg:flex-row'>
          <div className='flex flex-col items-center gap-1 md:flex-row md:gap-2'>
            <div className='flex items-center gap-2 border-legal-brown pr-2 font-semibold text-legal-light-gray md:border-r-2'>
              <FaRegCopyright />
              <p>Legalites 2025</p>
              <FaMinus />
              <p>All Rights Reserved</p>
            </div>

            <div className='border-legal-brown pr-2 md:border-r-2'>
              <div className='group relative'>
                <a
                  href='/policy'
                  className='font-semibold text-legal-light-gray duration-300 group-hover:text-legal-white'
                >
                  Privacy Policy
                </a>

                <div className='absolute h-[2px] w-0 bg-legal-brown duration-300 group-hover:w-full'></div>
              </div>
            </div>

            <div className='group relative font-marcellus'>
              <a
                href='/terms'
                className='font-semibold text-legal-light-gray duration-300 group-hover:text-legal-white'
              >
                Terms & Conditions
              </a>

              <div className='absolute h-[2px] w-0 bg-legal-brown duration-300 group-hover:w-full'></div>
            </div>
          </div>

          <div className='mt-3 flex items-center justify-center gap-1 font-semibold text-legal-white md:mt-0'>
            <p>Designed & Developed by</p>
            <p>
              <a
                href='https://www.kirrhosoft.com/'
                className='text-[#F69E1A] duration-300 hover:opacity-70'
                target='_blank'
                rel='noreferrer'
              >
                Kirrho<span className='text-[#78B445]'>soft</span>
              </a>{' '}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
